<template>
  <div class='indexbox' v-loading='loading'></div>
</template>
<script>
  export default {
    components: {},
    data() {
      return {
        loading: true
      }
    },
    computed: {},
    watch: {},
    methods: {},
    created() {
      const path = this.$route.query.redirect
      this.$router.replace(path)
    },
  }
</script>